import { tsUtils } from '@neo-one/ts-utils';
import ts from 'typescript';
import { BuiltinInstanceMemberCall } from '../BuiltinInstanceMemberCall';
export class ArrayFilter extends BuiltinInstanceMemberCall {
    canCall(_sb, _func, node) {
        return ts.isCallExpression(node) && tsUtils.argumented.getArguments(node).length === 1;
    }
    emitCall(sb, func, node, optionsIn, visited) {
        const options = sb.pushValueOptions(optionsIn);
        if (!visited && (ts.isPropertyAccessExpression(func) || ts.isElementAccessExpression(func))) {
            sb.visit(tsUtils.expression.getExpression(func), options);
        }
        if (tsUtils.argumented.getArguments(node).length < 1) {
            return;
        }
        sb.emitHelper(node, options, sb.helpers.unwrapArray);
        sb.visit(tsUtils.argumented.getArguments(node)[0], options);
        sb.emitHelper(node, options, sb.helpers.arrFilterFunc);
        if (optionsIn.pushValue) {
            sb.emitHelper(node, options, sb.helpers.wrapArray);
        }
        else {
            sb.emitOp(node, 'DROP');
        }
    }
}

//# sourceMappingURL=filter.js.map
